import React from 'react';
import LeftNav from './LeftNav';
import '../styles/Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <LeftNav />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout;
